import appConfig from '@/config'

/**
 * 合并接口模型
 * @author yangyu
 */
export default (api = {}) => {
  for (let key in api) {
    if (api.hasOwnProperty(key)) {
      let apis = api[key].api
      let BASE_URL = api[key].BASE_URL
      if (BASE_URL.startsWith('/') && BASE_URL.length > 1) { BASE_URL = BASE_URL.substring(1) }
      if (BASE_URL.endsWith('/') && BASE_URL.length > 1) { BASE_URL = BASE_URL.substring(0, BASE_URL.length - 1) }
      if (BASE_URL && BASE_URL === '/') BASE_URL = ''
      else if (BASE_URL === undefined || BASE_URL === null) BASE_URL = ''
      apis.forEach((_) => {
        if (_.path === undefined) throw new Error('path不能为空')
        if (!_.name) throw new Error('name不能为空')
        let path = _.path
        if (path.startsWith('/')) path = path.substring(1)
        _.path = `${
          appConfig.baseURL.startsWith('/')
            ? appConfig.baseURL
            : '/' + appConfig.baseURL
        }/${BASE_URL}/${path}`
        _.mockPath = `${
          appConfig.mockBaseURL.startsWith('/')
            ? appConfig.mockBaseURL
            : '/' + appConfig.mockBaseURL
        }/${BASE_URL}/${path}`
        _.BASE_URL = BASE_URL
      })
      api[key] = apis
    }
  }
  return api
}



// WEBPACK FOOTER //
// ./src/utils/api.js